import React from 'react';
import { Column, Row } from '../../../../components/Grid';
import { ContentHeader } from '../../../../components/layout/ContentHeader';
import { Section } from '../../../../components/Section';
import TypoVideo from '../../../../components/TypoVideo';
import { selectDoktype } from '../../../../provider/Typo3Provider/selectors';
import { CType, Typo3State } from '../../../../provider/Typo3Provider/types';
import { withTypo3 } from '../../../../provider/Typo3Provider/withTypo3';

type FullVideoProps = CType & {
  typo3: Typo3State;
};

const FullVideo = ({ files, header, subheader, typo3 }: FullVideoProps) => {
  const doktype = selectDoktype(typo3);
  return (
    <Section>
      <ContentHeader doktype={doktype} header={header} subheader={subheader} />
      <Row>
        <Column small={12}>{files ? <TypoVideo file={files}/> : null}</Column>
      </Row>
    </Section>
  );
};

export default withTypo3(FullVideo);
